import {Component} from "@angular/core";

@Component({

  template:`

<div class="big-about">

    <div class="middle-box">
        <br>

        <h2>關於波爾桌球</h2><br>

        <div class="line-about"></div><br>

        <p>
            我們希望讓每一把拍子找到它的主人，<br>而每個球友都帶著最適合自己的拍子離開，<br><br>一直是我們成立波爾桌球用品專賣店的使命。

        </p>

    </div>

</div>

<div class="container">

    <div class="title-clothes">

        <div class="title-clothes-line"></div>關於我們<div class="title-clothes-line2"></div>

    </div>


    <div class="about-text">

        <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;每支球拍都有自己的故事，昂貴的球具並不意味著適合自己！

            讓每把拍子都能夠找到它的主人，也讓每位主人都因為擁有它而感動不已．．．<br><br>

            －緣起－<br>

            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我們總是滔滔不絕地講著拍子和皮的那些事兒，從拍子的製作、最新的桌壇技術，到特注（訂製）和紀念球拍的收藏，一講起來就一定雙眼放著光。一開始與眾多球友一樣，我們都是因為太喜歡把玩各種拍子，一頭栽進桌球器材的世界。無論是那些悉心收藏愛不釋手的經典拍，或是忍不住心頭搔癢想要馬上試打的新品球拍，還有腦中無意間迸出拍子和皮的配置靈感，就這樣愈來愈多寶物在我們手中流轉往。流著轉著，這些寶物讓我們轉出了這間”波爾桌球用品專賣店”。<br><br>

            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;對我們來說，每支球拍都擁有自己的故事、自己的個性，即使是同一款拍子，製造出廠的批次不同、上面木紋的疏密，甚至拍柄底部釘上的鐵牌，都訴說著這支拍子的與眾不同。而不論標籤上的金額多少，當它換上適合的新皮，拿到對的人手中，都可能變成他獨一無二的神器，成為陪伴他征戰廝殺的戰友。拍子並不僅僅是一塊高科技的木頭，就像金庸小說裡楊過手中的玄鐵重劍一樣，它擁有主人的個性與風骨，訴說著主人的名號跟輝煌。而讓球友們找到最適合自己風格特長的拍子，又能夠讓這把拍子磨合出命運的膠皮配置，是我們開店至今的初衷。<br>
        </p>

        <div class="classroom-img">

            <img src="../../img/about4.jpg" width="250px" height="250px">



        </div>

        <div class="classroom-img" align="center">

            <img src="../../img/about5.jpg" width="250px" height="250px">



        </div>

        <div class="classroom-img">

            <img src="../../img/about6.jpg" width="250px" height="250px">



        </div><br><br>

        <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;為了能夠貫徹這樣的理念，我們盡可能地讓各大廠牌進駐店內，無論是從桌球界的領導品牌Butterfly、日本品牌Ｍizuno、Ｎittaku、歐洲知名品牌STIGA、DONIC、Andro、Yasaka以及中國最大廠牌”紅雙喜”⋯等，為了就是要讓廣大球友們能夠有更多的選擇。此外，我們在產品的品質管理上也兢兢業業、從不馬虎，若球友們在購買後發現產品有先天上的瑕疵，也都能夠提供完善的退換貨服務。

            讓每一把拍子找到它的主人，是我們的使命。一支拍子舉凡木材的特性、碳纖夾層的設計、拍柄的形狀粗細、球拍重量，一直到膠皮的硬度、海綿厚度等因素，都影響著這支拍子與主人的契合程度。<br><br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;也因此我們認為，最好的服務除了讓球友們在挑選器材的同時，獲得更專業的討論與建議外，有機會馬上體驗自己用心思索所挑選出來的球拍，使每個人都能夠帶著最適合自己的球拍踏出這家店。

            「昂貴的球具並不意味著適合自己！」我們秉持著這樣的理念，從一顆桌球「玩」童的心出發來經營這家店，也希望愈來愈多的「玩」童一起來店裡聊桌球、交朋友，我們不願意只是當個生意人，我們要顛覆傳統，投入我們對桌球的熱情與信念，讓每一位桌球迷都能夠因為擁有屬於自己的球拍而感動不已。

        </p>
    </div>

    <div class="classroom-img">

        <img src="../../img/about1.jpg" width="250px" height="250px">



    </div>

    <div class="classroom-img" align="center">

        <img src="../../img/about2.jpg" width="250px" height="250px">



    </div>

    <div class="classroom-img">

        <img src="../../img/about3.jpg" width="250px" height="250px">



    </div>

</div>

<br><br>

<div class="container">
    <div class="title-clothes">
        <div class="title-clothes-line"></div>總店資訊<div class="title-clothes-line2"></div>
    </div>
    <div class="classroom-last-text">
        <p>
            電話：(02) 3151-7171 <br>
            <br>
            Line ID: 0986-465-666 <br>
            <br>
            營業時間：
            星期一 店休, 星期二～五 12:30 ~ 20:00, 星期六、日 11:30 ~ 18:00 <br>
            <br>
            地址：新北市中和區自強路60號【秀山國小旁】<br>
            <br>
            <br>
            <iframe src="https://calendar.google.com/calendar/b/1/embed?height=600&amp;wkst=1&amp;bgcolor=%23D81B60&amp;ctz=Asia%2FTaipei&amp;src=c2I1NTh0MWM3YXJoam1hdWJjczJpbTEwY2tAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&amp;color=%23D81B60&amp;showTitle=1&amp;title=%E6%B3%A2%E7%88%BE%E4%B8%AD%E5%92%8C%E7%B8%BD%E5%BA%97%E3%80%8E%E5%BA%97%E4%BC%91%E6%97%A5%E3%80%8F&amp;showNav=0&amp;showDate=1&amp;showPrint=0&amp;showTabs=0&amp;showCalendars=0&amp;showTz=0" style="border-width:0" width="800" height="300" frameborder="0" scrolling="no"></iframe><br>
            <br>
            <br>
            交通資訊：(1.)捷運橘線【永安市場站】＝> 橘2或57號公車 搭至【秀山站】<br>
                    <br>
                    (2.)捷運橘線【頂溪站】＝> 57號公車 搭至【秀山站】<br>
                    <br>
                    (3.)捷運環狀線【景平站】＝> 步行7-10分鐘<br>
                    <br>
            停車資訊：(1.)泡泡龍停車場(全家便利商店對面)<br>
                    <br>
                    (2.)愛買永和店停車場<br>
                    <br>                  
                    (3.)北城停車場<br>
                    <br>                  
                    (4.)秀山公園地下停車場<br>                     
        </p>
        <p>
        <br>
        <iframe src="https://www.google.com/maps/d/embed?mid=1uGNpgzHmUozZIyMnvqksKi88ppnZn6S_&hl=zh-TW" width="640" height="480"></iframe>
        </p>

    </div>
    
</div>

    `
})

export class AboutComponent{

}



// WEBPACK FOOTER //
// ./src/app/Home/about.component.ts